var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12323",
    "data-name": "Group 12323",
    transform: "translate(-16 -179)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_867",
    "data-name": "Ellipse 867",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(16 179)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(21.39 110.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12316",
    "data-name": "Group 12316",
    transform: "translate(11.159 76.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12315",
    "data-name": "Group 12315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5574",
    "data-name": "Path 5574",
    d: "M357.13,101.721l-4.919,4.888,4.919,4.888a1.409,1.409,0,0,0,.143-.611v-8.554A1.409,1.409,0,0,0,357.13,101.721Z",
    transform: "translate(-352.211 -101.721)",
    fill: "#ed8b00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12318",
    "data-name": "Group 12318",
    transform: "translate(0.815 76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12317",
    "data-name": "Group 12317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5575",
    "data-name": "Path 5575",
    d: "M39.7,76H26.332a1.409,1.409,0,0,0-.611.143L32.009,82.4a1.427,1.427,0,0,0,2.016,0l6.288-6.256A1.409,1.409,0,0,0,39.7,76Z",
    transform: "translate(-25.721 -76)",
    fill: "#ed8b00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12320",
    "data-name": "Group 12320",
    transform: "translate(0 76.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12319",
    "data-name": "Group 12319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5576",
    "data-name": "Path 5576",
    d: "M.143,101.721a1.409,1.409,0,0,0-.143.611v8.554a1.409,1.409,0,0,0,.143.611l4.919-4.888Z",
    transform: "translate(0 -101.721)",
    fill: "#ed8b00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12322",
    "data-name": "Group 12322",
    transform: "translate(0.815 82.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12321",
    "data-name": "Group 12321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5577",
    "data-name": "Path 5577",
    d: "M35.393,277.211l-.7.7a2.379,2.379,0,0,1-3.36,0l-.7-.7L25.721,282.1a1.409,1.409,0,0,0,.611.143H39.7a1.409,1.409,0,0,0,.611-.143Z",
    transform: "translate(-25.721 -277.211)",
    fill: "#ed8b00"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon_help.c58b42a3e8e70fd3a5f842be33133cd6.svg";
export { ForwardRef as ReactComponent };